/**
 * The worksheet question types the app actually understands.
 *
 * This used to live as a private `TYPE_OPTIONS` const inside WorksheetModule,
 * which meant every other surface that offered a question-type picker was
 * guessing. The AI Prompt page guessed `multiple-choice`, which matches neither
 * this list nor the legacy names WorksheetModule migrates from, so picking
 * "Multiple Choice" there silently produced a short-answer question.
 *
 * Anything that offers question types, documents them to an LLM, or validates
 * them should read this list rather than restating it.
 */
export const WORKSHEET_QUESTION_TYPES = [
  { value: 'instructions', label: 'Instructions', hint: 'Standing instructions, not a question' },
  { value: 'mcq', label: 'Multiple Choice', hint: 'Needs an options array' },
  { value: 'true-false', label: 'True / False' },
  { value: 'short-answer', label: 'Short Answer' },
  { value: 'long-answer', label: 'Long Answer' },
  { value: 'fill-blank', label: 'Fill in the Blank' }
];

export const WORKSHEET_QUESTION_TYPE_VALUES = WORKSHEET_QUESTION_TYPES.map((option) => option.value);

export const DEFAULT_WORKSHEET_QUESTION_TYPE = 'short-answer';

export const isWorksheetQuestionType = (value) => WORKSHEET_QUESTION_TYPE_VALUES.includes(value);

/**
 * Question types written by older exports. WorksheetModule migrates these on
 * import; new content should never emit them.
 */
export const LEGACY_WORKSHEET_QUESTION_TYPES = {
  shortAnswer: 'short-answer',
  longAnswer: 'long-answer',
  multipleChoice: 'mcq',
  checkboxes: 'mcq'
};
